import { css } from '@emotion/react';
import { useTranslation } from '~/_shared/utils/hooks';
import type { ReportDemographicData } from '~/exportReport/exportReportData.helpers';
import type { ReportTemplate } from '~/exportReport/template/reportTemplate';
import { ExportReportTemplateRendererComponent } from '~/exportReport/templateRenderer/exportReportTemplateRenderer.component';
import { useExportReportParams } from '~/exportReport/useExportReportParams';
import type { ExportReportDriveTimePolygonParams } from '~/store/mapSettings/toolsState/exportReport/exportReportToolState.state';

const wrapperStyle = css({
  padding: 20,
  maxWidth: 1000,
  margin: '0 auto',
});

type MapExportReportPreviewDriveTimePolygonProps = Readonly<{
  params: ExportReportDriveTimePolygonParams;
  template: ReportTemplate;
  getDemographicLabel: (demographicId: string) => string | null;
  getDemographicData: (columnId: string, demographicId: string) => ReportDemographicData | null;
  isLoading: boolean;
}>;

export const MapExportReportPreviewDriveTimePolygonComponent = ({
  template, params, getDemographicData, getDemographicLabel, isLoading,
}: MapExportReportPreviewDriveTimePolygonProps) => {
  const { tableColumns } = useExportReportParams();
  const [t] = useTranslation();

  return (
    <div css={wrapperStyle}>
      <ExportReportTemplateRendererComponent
        template={template}
        tableColumns={tableColumns}
        summaryProps={{
          heading: t('Drive Time Polygon'),
        }}
        mapProps={{
          type: params.type,
          paths: params.data.paths,
          center: params.data.center,
        }}
        getDemographicLabel={getDemographicLabel}
        getDemographicData={getDemographicData}
        isLoading={isLoading}
      />
    </div>
  );
};
